import React from 'react';
import { compose } from 'ramda';

import { Icon, RichText } from '@synergycms_core/components/generic';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailAlert.js';
import { validateAsyncComponent } from '../../HoC';
import connect from 'react-redux/es/connect/connect';
import actions from '../../../store/actions';
import AvailDatepicker from '../AvailDatepicker/AvailDatepicker.jsx';
import NewAvailButton from '../AvailDatepicker/NewAvailButton.jsx';
import { CSSTransition } from 'react-transition-group';
import { Loading } from '@synergycms_core/components/functional/Loading';
import RelatedAvail from './RelatedAvail';


const RichTextsAlert = compose(
  withThemeJSS({
    styleFile: styleFile.RichTextsAlert,
    displayName: 'RichTextsAlert'
  })
)(props => {
  let component;
  switch (props.type) {
    case 'alter_avail':
      component = (
        <div>
          <RichText
            innerStyle={['roboto16Black', 'bold']}
            translate={true}
            ucFirst={true}
            text={'_%no tenemos disponibilidad para la combinación de habitaciones y ocupantes que has solicitado%_'}
          />
          <br />
          <RichText
            innerStyle={['roboto16Black', 'normal']}
            translate={true}
            ucFirst={true}
            text={
              '_%a continuación encontrarás otros tipos de habitación disponible para el mismo número de personas%_'
            }
          />
        </div>
      );
      break;
    case 'max_nights':
      component = (
        <div>
          <RichText
            innerStyle={['roboto16Black', 'bold']}
            translate={true}
            ucFirst={true}
            text={'_%ha superado el número máximo de noches permitidas para reservar online%_'}
          />
          <br />
          <RichText
            innerStyle={['roboto16Black', 'normal']}
            translate={true}
            ucFirst={true}
            text={'_%por favor, contacte con el hotel para que le hagan una propuesta a medida para largas estancias%_'}
          />
        </div>
      );
      break;
    case 'min_nights':
      component = (
        <div>
          <RichText
            innerStyle={['roboto16Black', 'bold']}
            translate={true}
            ucFirst={true}
            withVars={props.objVars}
            text={'_%estancias con mínimo de {value} noches%_'}
          />
          <br />
          <RichText
            innerStyle={'roboto16Black'}
            translate={true}
            ucFirst={true}
            text={'_%por favor, modifica tus criterios o amplia el periodo de búsqueda e inténtalo de nuevo%_'}
          />
        </div>
      );
      break;
    case 'selection_avail':
      component = (
        <div>
          <RichText
            innerStyle={['roboto16Black', 'bold']}
            translate={true}
            ucFirst={true}
            text={'_%no tenemos disponibilidad para los filtros que has seleccionado.%_'}
          />
        </div>
      );
      break;
    case 'no_avail':
    default:
      component = (
        <div>
          <RichText
            innerStyle={['roboto16Black', 'bold']}
            translate={true}
            ucFirst={true}
            text={'_%no tenemos disponibilidad para los criterios que has seleccionado%_'}
          />
          <br />
          <RichText
            innerStyle={'roboto16Black'}
            translate={true}
            ucFirst={true}
            text={'_%por favor, modifica tus criterios o amplia el periodo de búsqueda e inténtalo de nuevo%_'}
          />
        </div>
      );
      break;
  }
  return component;
});


const AvailAlert = class AvailAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPhoto: 0,
      showDatepickerAvail: false,
      showCalendar: false,
      hover: false,
      showMapToolTip: false,
    };
    this.cx = props.theme.bind();
  }
  static displayName = 'AvailAlert';
  
  onRangeChange = (dates) => {
    this.setState(state => ({
      dates: dates
    }));
  };

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };
  
  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    let showButton = config.showButton;
    const showCalendar = config.showCalendar ?? true;
    const showRelated = config.showRelated ?? true;

    return (
      <div className={[theme.computedInnerStyle, this.cx({filterAvail: config.type === 'selection_avail'})].join(' ')}>
        <div className={classes.alertContainer}>
          <div className={classes.alertIcon}>
            <Icon svg={'noDispoCalendar'} innerStyle={['mainColorSvg']} />
          </div>
          <div className={classes.alertText}>{<RichTextsAlert type={config.type} objVars={config.objVars} />}</div>

        </div>


        {showCalendar && this.isMobile() && (
          <>
            {showButton ? (
              <div>
                <CSSTransition
                  in={this.state.showDatepickerAvail}
                  timeout={700}
                  mountOnEnter
                  unmountOnExit
                  classNames={{
                    enter: classes.roomPreferenceEnter,
                    enterActive: classes.roomPreferenceEnterActive,
                    exit: classes.roomPreferenceLeave,
                    exitActive: classes.roomPreferenceLeaveActive
                  }}
                >
                  <div className={classes.noDispoCalendarContainer}>
                    <AvailDatepicker
                      inAvail={true}
                      months={2}
                      start={this.props.config.date}
                      onRangeChange={this.onRangeChange}
                      innerStyle={'availDatepickerModal'}
                    />
                    <NewAvailButton dates={this.state.dates} />
                  </div>
                </CSSTransition>
              </div>
            ) : (
              <div className={classes.noDispoCalendarContainer}>
                <AvailDatepicker
                  inAvail={true}
                  months={1}
                  mobileArrows={true}
                  start={this.props.config.date}
                  onRangeChange={this.onRangeChange}
                  innerStyle={'availDatepickerModal'}
                />
                <NewAvailButton dates={this.state.dates} />
              </div>
            )}
          </>
        )}
        {showCalendar && !this.isMobile() && (
          <>
            {showButton ? (
              <div>
                <CSSTransition
                  in={this.state.showDatepickerAvail}
                  timeout={700}
                  mountOnEnter
                  unmountOnExit
                  classNames={{
                    enter: classes.roomPreferenceEnter,
                    enterActive: classes.roomPreferenceEnterActive,
                    exit: classes.roomPreferenceLeave,
                    exitActive: classes.roomPreferenceLeaveActive
                  }}
                >
                  <div className={classes.noDispoCalendarContainer}>
                    <AvailDatepicker
                      inAvail={true}
                      months={2}
                      start={this.props.config.date}
                      onRangeChange={this.onRangeChange}
                      innerStyle={'availDatepickerModal'}
                    />
                    <NewAvailButton dates={this.state.dates} />
                  </div>
                </CSSTransition>
              </div>
            ) : (
              <div className={classes.noDispoCalendarContainer}>
                <AvailDatepicker
                  inAvail={true}
                  months={2}
                  start={this.props.config.date}
                  onRangeChange={this.onRangeChange}
                  innerStyle={'availDatepickerModal'}
                />
                <NewAvailButton dates={this.state.dates} />
              </div>
            )}
          </>
        )}
        {showRelated && <RelatedAvail config={config} theme={theme} />}
      </div>
    );
  }
};


const mapDispatchToProps = dispatch => {
  return {
    showEngine: () => () => {
      dispatch(actions.customer.header.show('engine', true));
    }
  };
};

const mapStateToProps = store => {
  const urlParams = store.getIn(['customer', 'params', 'url_params'], undefined);
  

  return {
    urlParams,
  };
};
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    showEngine: dispatchProps.showEngine(stateProps.urlParams.toJS())
  });
};


const fragment = props => {

  const engineSygyData = window.engine_sygy_data;
  const { webType } = props;
  const group = engineSygyData && engineSygyData.group;
  const corporateLogin = window.LoginUser && +window.LoginUser.tipo_perfil === 1 ? window.LoginUser : null;
  const loyaltyLogin = window.LoginUser && +window.LoginUser.tipo_perfil === 2 ? window.LoginUser : null;
  const userLogIn = (corporateLogin && corporateLogin.usuario !== 'NoLogin') || (loyaltyLogin && loyaltyLogin.usuario !== 'NoLogin');

  return (
    <React.Fragment>
      <Loading
        richText={{
          ucFirst: true,
          innerStyle: ['descriptionText'],
          text: '_%estamos buscando los mejores precios para ti%_',
          translate: true
        }}
        showLoyaltyBanner={webType === 'PORTAL' && group === 'eurostarshotels' && !userLogIn}
      />
    </React.Fragment>
  );
};

export default compose(
  validateAsyncComponent(mapStateToProps,[],fragment),
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  PropertyManager(['type', 'showButton', 'urlParams', 'currentDate', 'availDate', 'showEngine', 'goBack', 'objVars', 'newRange','showCalendar','showRelated']),
  withThemeJSS({ styleFile, link: true })
)(AvailAlert);